import Project from "../../components/project/project";
import React from "react";
import {Carousel,Image} from "react-bootstrap";

class Thesis extends Project{

    constructor(props) {
        super(props);
        this.images = ["ica.task.1.png","pie.task.1.png","scatter.task.1.png"];
    }

   get_images() {
        return(
           <Carousel>
               {this.images.map((img_name) => {
                   return(
                       <Carousel.Item>
                           <Image
                               className="d-block"
                               style={{marginLeft:"auto",marginRight:"auto"}}
                               src={"img/projects/thesis/"+img_name}
                               alt={img_name}
                           />
                       </Carousel.Item>
                   )
               })}
           </Carousel>
       )
   }

    get_description() {
        return(
            <p>
                I got tired of having one too many "Compile Time Exceeded" messages from overleaf and was very sad
                to see that even though it is <a className={"text-bg-secondary"} href="https://github.com/overleaf/overleaf">open source</a>,
                integrating with git is a <i>premium</i> feature. A friend of mine mentioned that he used <code>make</code> to
                build his thesis, so I promptly set up one for my own. Then added a build pipeline to the repo that
                called it, then added a bunch of <code>matplotlib</code> code to build my graphs and before I knew it,
                I had set up a build ecosystem for my thesis that allowed me to auto-update my graphs when changes
                were made to the database that held my study results and selectively compile my thesis depending on
                where I was publishing to. I also learned a lot about how to create latex directives and made many of
                them to format common elements/sections of my thesis. I'm not sure how non-programmers use Latex, but
                I was certainly aided by the programming paradigms I've learned when I wrote this. It saved me a lot
                of time when some "regressions" were introduced in the form of formatting requests from my supervisor.

            </p>
        )
    }

    get_challenge() {
        return(
            <ul>
               <li>
                   <p>
                       <b>Avoiding committing many image files</b>: Because different publications were using
                       different versions of different figures, and I had many images that I could simply
                       generate with my graph-builder, I just created a symbolic link to the directory where
                       all of my images were being built to on my lab machine in the <code>/images</code> directory.
                   </p>
               </li>
               <li>
                  <p>
                      <b>Style Issues</b>: as I was writing my thesis, I learned that I am terrible for a few things
                      <ol>
                          <li>Putting Random Capitals in my sentences, </li>
                          <li>Not putting spaces before calling a <code>\cite</code> directive, and</li>
                          <li>Using " " rather than `` '' (the latex preferred/consistent quote characters).</li>
                      </ol>
                      Old habits die hard, so I wrote a "Linter" (pretty generous term, its just a sed + grep script)
                      that reformats all of my documents to fix these before it builds the final PDF.
                  </p>
               </li>
           </ul>
        )
    }

    icon_mapper(tech){
        let postfix =  "-plain";
        let prefix = tech
        if(tech === "linux-services")
            prefix = "linux"
        if(tech === "raspberry pi"){
            prefix = "raspberrypi";
            postfix="-line";
        }

        return prefix + postfix;
    }
}

export default Thesis;